<template>
  <div>
    <div v-if="appUtilities.moduleLoadingSeven">
      <BaseComponentLoader />
    </div>
    <div v-else>
      <form @submit.prevent="submitForm">
        <div class="row">
          <div class="col-6">
            <CustomerAccountCard :account="tillAccount" destination="from" />
          </div>

          <div class="col-6">
            <CustomerAccountCard
                :account="ft.stageOneResponse"
                destination="to"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <div>
              <BaseInput
                  :inputType="'amount'"
                  v-model="formBody.trnAmount"
                  placeholder="Amount"
                  :hasPreIcon="false"
                  :label="'Amount'"
                  :class="{
                  error: $v.formBody.trnAmount.$error
                }"
                  @blur="$v.formBody.trnAmount.$touch()"
              >
              </BaseInput>

              <template v-if="$v.formBody.trnAmount.$error">
                <p
                    v-if="!$v.formBody.trnAmount.required"
                    class="form-error-message"
                >
                  Amount is required
                </p>
              </template>
            </div>
          </div>

          <div class="col-sm-6">
            <div>
              <div class="form-group">
                <label>FT Product</label>
                <multiselect
                    v-model="formBody.ftProductCode"
                    :options="ftProductCodeUtilityOption"
                    @close="$v.formBody.ftProductCode.$touch()"
                    placeholder="FT Product"
                ></multiselect>
              </div>
              <template v-if="$v.formBody.ftProductCode.$error">
                <p
                    v-if="!$v.formBody.ftProductCode.required"
                    class="form-error-message"
                >
                  FT Product is required
                </p>
              </template>
            </div>
          </div>

          <div class="col-sm-6">
            <div>
              <BaseInput
                  :inputType="'text'"
                  v-model="formBody.trnNarration"
                  placeholder="Narration"
                  :hasPreIcon="false"
                  :label="'Narration'"
                  :class="{
                  error: $v.formBody.trnNarration.$error
                }"
                  @blur="$v.formBody.trnNarration.$touch()"
              >
              </BaseInput>

              <template v-if="$v.formBody.trnNarration.$error">
                <p
                    v-if="!$v.formBody.trnNarration.required"
                    class="form-error-message"
                >
                  Narration is required
                </p>
              </template>
            </div>
          </div>

          <div class="col-sm-6">
            <div>
              <label>Withdrawal Type </label>
              <p class="counter-party-radio">
                <span>
                  <span class="custom-control custom-radio mb-3">
                    <input
                        type="radio"
                        id="customRadio1"
                        class="custom-control-input"
                        value="self"
                        v-model="counterPartyStatus"
                    />
                    <label class="custom-control-label" for="customRadio1"
                    >Self</label
                    >
                  </span>
                </span>

                <span>
                  <span class="custom-control custom-radio mb-3">
                    <input
                        type="radio"
                        id="customRadio2"
                        class="custom-control-input"
                        value="counter-party"
                        v-model="counterPartyStatus"
                    />
                    <label class="custom-control-label" for="customRadio2"
                    >Counterparty</label
                    >
                  </span>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div v-if="counterPartyStatus === 'counter-party'" class="row">
          <div class="col-sm-6">
            <div>
              <BaseInput
                  :inputType="'text'"
                  v-model="formBody.counterPartyAccountName"
                  placeholder="Counter Party Name"
                  :hasPreIcon="false"
                  :label="'Counter Party Name'"
                  required
              >
              </BaseInput>
            </div>
          </div>

          <div class="col-sm-6">
            <div>
              <BaseInput
                  :inputType="'number'"
                  v-model="formBody.counterPartyPhone"
                  placeholder="Counter Phone Number"
                  :hasPreIcon="false"
                  :label="'Counter Phone Number'"
                  required
              >
              </BaseInput>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <p class="text-left">
              <span>
                <button
                    @click="goBackToStageOne"
                    class="btn btn-secondary mr-1"
                >
                  Back
                </button>
              </span>
            </p>
          </div>
          <div class="col-sm-6">
            <p class="text-right">
              <span v-if="loader.actionButtonLoader" class="formLoaderHold">
                <BaseComponentLoader />
              </span>
              <span v-else>
                <button type="submit" class="btn btn-primary mr-1">
                  Transfer
                </button>
              </span>
            </p>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import StoreUtils from "../../../../../utils/BaseUtils/StoreUtils";
import { required } from "vuelidate/lib/validators";
import CustomerAccountCard from "../../../Cards/FT/CustomerAccountCard";

export default {
  name: "CdFinalForm",
  components: { CustomerAccountCard },
  data() {
    return {
      formBody: this.freshFormBodyObject(),
      counterPartyStatus: "self"
    };
  },
  computed: {
    ...mapState(["ft", "loader", "appUtilities"]),
    ...mapGetters({
      getBankNameFromIdUtility: "appUtilities/getBankNameFromCodeUtility",
      ftProductCodeUtilityOption: "appUtilities/getFtProductCodeUtilityOption",
      getTransactionCodeUtilityOption:
          "appUtilities/getTransactionCodeUtilityOption"
    }),
    tillAccount() {
      return {
        accountBankName: this.getBankNameFromIdUtility(
            StoreUtils.rootGetter(StoreUtils.getters.user.GET_USER_BANK_CODE)
        ),
        accountNumber:
            StoreUtils.rootGetter(
                StoreUtils.getters.user.GET_USER_TILL_ACCOUNT_NUMBER
            ) !== "" &&
            StoreUtils.rootGetter(
                StoreUtils.getters.user.GET_USER_TILL_ACCOUNT_NUMBER
            ) != null
                ? StoreUtils.rootGetter(
                    StoreUtils.getters.user.GET_USER_TILL_ACCOUNT_NUMBER
                )
                : StoreUtils.rootGetter(
                    StoreUtils.getters.user.GET_USER_VAULT_ACCOUNT_NUMBER
                ),
        accountName:
            StoreUtils.rootGetter(
                StoreUtils.getters.user.GET_USER_TILL_ACCOUNT_NUMBER
            ) !== "" &&
            StoreUtils.rootGetter(
                StoreUtils.getters.user.GET_USER_TILL_ACCOUNT_NUMBER
            ) != null
                ? "Till Account"
                : "Vault Account",
        accountBalance: this.ft.tillBalance
      };
    },
    tillAccountName() {
      return "Till Account";
    },
    tillAccountNumber() {
      return StoreUtils.rootGetter(
          StoreUtils.getters.user.GET_USER_TILL_ACCOUNT_NUMBER
      ) !== "" &&
      StoreUtils.rootGetter(
          StoreUtils.getters.user.GET_USER_TILL_ACCOUNT_NUMBER
      ) == null
          ? StoreUtils.rootGetter(
              StoreUtils.getters.user.GET_USER_TILL_ACCOUNT_NUMBER
          )
          : StoreUtils.rootGetter(
              StoreUtils.getters.user.GET_USER_VAULT_ACCOUNT_NUMBER
          );
    },
    tillAccountBankName() {
      return this.getBankNameFromIdUtility(
          StoreUtils.rootGetter(StoreUtils.getters.user.GET_USER_BANK_CODE)
      );
    }
  },
  validations: {
    formBody: {
      ftProductCode: { required },
      trnAmount: { required },
      trnNarration: { required }
    }
  },
  created() {
    this.$store.dispatch("appUtilities/fetchAllFundsTransferProduct", null, {
      root: true
    });
  },
  mounted() {
    StoreUtils.dispatch("ft/fetchTillAccountBalance", this.tillAccountNumber);
  },
  methods: {
    goBackToStageOne() {
      StoreUtils.dispatch(StoreUtils.actions.ft.GO_BACK_TO_STAGE_ONE);
    },
    submitForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        StoreUtils.dispatch(StoreUtils.actions.ft.CASH_DEPOSIT, this.formBody);
      }
    },

    freshFormBodyObject() {
      return {
        source: "WEB"
      };
    }
  }
};
</script>

<style scoped></style>
